import React from "react";
import {
  Toolbar,
  useUpdate,
  useRedirect,
  useNotify,
  useRecordContext,
} from "react-admin";
import { CANCELLED } from "../components/Constant";
import { useFormContext } from "react-hook-form";
import { dirtyValues } from "../helpers/methods";
import { Button } from "@mui/material";

const EditOrderToolbar = () => {
  const record = useRecordContext();
  const {
    getValues,
    formState: { dirtyFields, isValid },
  } = useFormContext();
  const [update, { isLoading }] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSave = (redirectTo) => () => {
    const values = getValues();
    const {
      recalculateStock = false,
      userRef,
      page,
      contact,
      ...otherValues
    } = values;

    const updateId =
      values.status === CANCELLED && recalculateStock
        ? `${record.id}?recalculateStock=true`
        : record.id;

    const basePath = window.location.hash.split("/")[1];

    update(
      "orders",
      {
        id: updateId,
        data: { ...dirtyValues(dirtyFields, otherValues) },
        previousData: record,
      },
      {
        onSuccess: (data) => {
          notify("Element Updated", { type: "info" });
          if (redirectTo === "show") {
            redirect(`/${basePath}/${record.id}/show`);
          } else {
            redirect(`/${basePath}`);
          }
        },
        onError: (err) => {
          notify(err.message, {
            type: "error",
            autoHideDuration: 30000,
          });
        },
      }
    );
  };

  return (
    <Toolbar>
      <Button
        type="button"
        onClick={handleSave("show")}
        disabled={isLoading || !isValid}
        variant="contained"
      >
        Save & Show
      </Button>
      <Button
        type="button"
        onClick={handleSave("list")}
        disabled={isLoading || !isValid}
        variant="outlined"
      >
        Save & List
      </Button>
    </Toolbar>
  );
};

export default EditOrderToolbar;
